var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-code',{attrs:{"title":"แผนที่"}},[_c('l-map',{attrs:{"zoom":_vm.zoom,"center":_vm.mapCenter}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_c('l-marker',{attrs:{"lat-lng":_vm.mapCenter}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }